import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

export const differimentKeys = {
  all: ['differiments'],
  summary: (filters) => [...differimentKeys.all, 'summary', filters],
};

export const useDifferiments = (filters, options = {}) => {
  const cuotaPura = filters?.cuotaPura ? Number(filters.cuotaPura) : undefined;
  return useQuery({
    queryKey: differimentKeys.summary({ cuotaPura }),
    queryFn: async () => {
      const response = await apiClient.get('differiments', cuotaPura ? { params: { cuota_pura: cuotaPura } } : undefined);
      return response.data || [];
    },
    enabled: true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options,
  });
};

export default useDifferiments;
